import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12057af2")

_pushScopeId("data-v-12057af2")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "nav-container flexbox-row justify-space-between padding-bottom-20 padding-top-20" }, [
  /*#__PURE__*/_createVNode("p", { class: "title color-white" }, "Pagamenti")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "p-text-left" }, [
  /*#__PURE__*/_createVNode("span", null, "PRENOTAZIONI")
], -1)
const _hoisted_3 = { class: "payments-settings-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "IMPOSTAZIONI", -1)
const _hoisted_5 = { class: "payments-settings-container" }
const _hoisted_6 = { class: "header margin-top-20 margin-bottom-20 p-text-left " }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "header-title" }, "PAGAMENTI ONLINE", -1)
const _hoisted_8 = { class: "p-d-inline-flex p-mr-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "header-title" }, " ", -1)
const _hoisted_10 = { class: "p-d-inline-flex p-ml-4" }
const _hoisted_11 = { class: "margin-top-40 margin-bottom-20 " }
const _hoisted_12 = { class: "nexi-subscription-detail-container margin-top-10 margin-bottom-20" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "margin-bottom-20" }, " Permetti ai tuoi clienti di pagare in anticipo online. WeSmash permette di ricevere i pagamenti tramite circuito Nexi. ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "margin-top-40" }, [
  /*#__PURE__*/_createVNode("strong", null, "Come funziona:")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "margin-top-20" }, [
  /*#__PURE__*/_createVNode("strong", null, "1. Vai su Nexi."),
  /*#__PURE__*/_createTextVNode(" L’attivazione e la firma (elettronica) del contratto avviene online sul sito Nexi. "),
  /*#__PURE__*/_createVNode("div", { class: "margin-top-10" }, [
    /*#__PURE__*/_createVNode("div", { class: "p-text-left p-d-flex" }, [
      /*#__PURE__*/_createVNode("div", { class: "button-container primary p-mt-2" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "button primary",
          target: "_blank",
          href: "https://ecommerce.nexi.it/guida-primafase?p=2"
        }, [
          /*#__PURE__*/_createVNode("span", { class: "label primary" }, "ATTIVA CONTRATTO NEXI")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "margin-top-40" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("strong", null, "2. Usa il codice promozionale."),
    /*#__PURE__*/_createTextVNode(" Utilizza il codice promozionale WeSmash in fase di attivazione del servizio. ")
  ]),
  /*#__PURE__*/_createVNode("div", {
    class: "margin-top-10",
    style: {"font-size":"20px !important"}
  }, [
    /*#__PURE__*/_createVNode("strong", null, "WESMASH")
  ])
], -1)
const _hoisted_17 = { class: "margin-top-40" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("strong", null, "3. Inserisci MAC e Alias."),
  /*#__PURE__*/_createTextVNode(" Dopo circa 8 giorni dall’attivazione del contratto Nexi riceverai i codici Alias e MAC di Nexi, e saremo in grado di indirizzare i pagamenti in modo corretto al tuo centro. ")
], -1)
const _hoisted_19 = {
  class: "p-grid margin-top-10",
  style: {"font-size":"20px !important"}
}
const _hoisted_20 = { class: "p-col-12 p-md-3 p-text-left" }
const _hoisted_21 = { class: "p-col-12 p-md-3 p-text-left" }
const _hoisted_22 = { class: "p-text-left p-d-flex" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "nexi-subscription-detail-container margin-top-20" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("strong", { class: "margin-top-40" }, [
      /*#__PURE__*/_createTextVNode(" Costi del servizio con il codice promozionale WeSmash (6f89gs4hnd9):"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createVNode("br")
    ]),
    /*#__PURE__*/_createVNode("ul", null, [
      /*#__PURE__*/_createVNode("li", null, " Attivazione: 7,50€ una tantum "),
      /*#__PURE__*/_createVNode("li", null, " Canone mensile: 2,50€ "),
      /*#__PURE__*/_createVNode("li", null, " 0,95% valore transazione "),
      /*#__PURE__*/_createVNode("li", null, " 0,10€ per transazione "),
      /*#__PURE__*/_createVNode("li", null, " 0,10€ per storno transazione ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "margin-top-40" }, " Sei già cliente Nexi? Richiedi una consulenza al tuo referente Nexi. ")
], -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "color-white montserrat" }, [
  /*#__PURE__*/_createVNode("strong", null, "Totale pagato: €."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Indica l'importo che vuoi rimborsare all'utente:")
], -1)
const _hoisted_27 = { class: "p-d-flex p-jc-center" }
const _hoisted_28 = { class: "p-d-flex p-jc-end" }
_popScopeId()

import { ActionTypes } from "@/store/action-types";
import { useStore } from "@/store/store";
// import { MutationTypes } from "@/store/mutation-types";
import { CardCategories } from "@/constants/card-types.enum";
import { PaymentWithBookingDto } from "@/generated-sources/gestioneclub-api";
import { PadelClub } from "@/models/club.models";
import { Transaction } from "@/models/transaction.models";
import {
  returnDateAdMidnight,
  returnTomorrow,
  returnYesterday
} from "@/services/dates.service";
import { uppercase } from "@/services/mapping.service";
import { MutationTypes } from "@/store/mutation-types";
import moment from "moment";
import { computed, defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import BookingPayments from "@/components/payment/BookingPayments.vue";

export default _defineComponent({
  setup(__props) {

/* eslint-disable */
const { t, locale } = useI18n();
const store = useStore();
const router = useRouter();
const selectedDate = ref(new Date());
const payments = ref(new Array<PaymentWithBookingDto>());
const showRefundModal = ref(false);
const refundPercentage = ref(100);
const selectedTransaction = ref(null as null | Transaction);
const refundOptions = ref([
  { value: 25, label: "" },
  { value: 50, label: "" },
  { value: 75, label: "" },
  { value: 100, label: "" }
]);

// TABS
const selectedTab = ref(0);
const showCalendar = ref(false);

// FORM
const alias = ref("");
const mac = ref("");
const paymentEnabled = ref(false);
const forceOnlinePayment = ref(false);

// Computed
const club = computed(function (): PadelClub {
  return store.getters.getMyClub;
});

// Functions
function onChangeTab(event) {
  selectedTab.value = event;
  if (selectedTab.value == 0) {
    // Transazioni - BookingPayments gestisce autonomamente il caricamento
  } else if (selectedTab.value == 1) {
    // Storni
    fetchRefunds();
  } else {
    // Impostazioni
  }
}

// Calendar
function toggleCalendar() {
  showCalendar.value = !showCalendar.value;
}

function hideCalendar() {
  showCalendar.value = false;
}

function changeDateWithCalendar(event: Date) {
  if (event.getTime() === selectedDate.value.getTime()) return;
  setTimeout(() => {
    hideCalendar();
  }, 1);

  selectedDate.value = new Date(event.getTime());
  fetchTransactions();
}

function goToToday() {
  selectedDate.value = new Date();
  if (selectedTab.value == 0) {
    fetchTransactions();
  } else if (selectedTab.value == 1) {
    fetchRefunds();
  }
}

function goToYesterday() {
  selectedDate.value = returnYesterday(selectedDate.value);
  if (selectedTab.value == 0) {
    fetchTransactions();
  } else if (selectedTab.value == 1) {
    fetchRefunds();
  }
}

function goToTomorrow() {
  selectedDate.value = returnTomorrow(selectedDate.value);
  if (selectedTab.value == 0) {
    fetchTransactions();
  } else if (selectedTab.value == 1) {
    fetchRefunds();
  }
}

function formatDate() {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    month: "long",
    day: "2-digit",
    year: "numeric"
  };
  const stringDate = selectedDate.value.toLocaleDateString(
    "it-IT",
    options
  );
  return (" " + stringDate)
    .replace(/ [\w]/g, a => a.toLocaleUpperCase())
    .trim();
}

async function handleToggleEnableNexiPayment(value: boolean) {
  const resp = await store.dispatch(ActionTypes.ENABLE_ONLINE_PAYMENT, {
    club_id: club.value.club_id,
    enable: value
  });
  await store.dispatch(ActionTypes.MY_CLUBS, null);
}

async function handleToggleForceNexiPayment(value: boolean) {
  // DISPATCH
  try {
    const payload = {
      phone_number: club.value.club_phone_number,
      email: club.value.email,
      opening_hour: club.value.opening_hour,
      closing_hour: club.value.closing_hour,
      services: club.value.services,
      player_categories: club.value.player_categories,
      forewarning: club.value.forewarning,
      club_category:
        club.value.club_category != null
          ? club.value.club_category
          : CardCategories.INSTITUTIONAL,
      force_online_payment: value
    };
    await store.dispatch(ActionTypes.CHANGE_CLUB_INFO, {
      club_id: club.value.club_id,
      request: payload
    });
    await store.dispatch(ActionTypes.MY_CLUBS, null);
  } catch (error) {
    console.error(error);
  }
}

async function fetchTransactions() {
  payments.value = [];
  const resp = await store.dispatch(ActionTypes.FETCH_PAYMENTS_FOR_CLUB, {
    clubId: club.value.club_id,
    // refund: false,
    date: returnDateAdMidnight(selectedDate.value).toISOString()
  });
  const records = resp;
  payments.value = records.sort(paymentComparator);
}

async function fetchRefunds() {
  payments.value = [];
  const resp = await store.dispatch(ActionTypes.FETCH_PAYMENTS_FOR_CLUB, {
    clubId: club.value.club_id,
    // refund: true,
    date: returnDateAdMidnight(selectedDate.value).toISOString()
  });
  const records = resp;
  payments.value = records.sort(paymentComparator);
}

async function saveNexiPaymentSettings() {
  await store.dispatch(ActionTypes.NEXI_SAVE_CONFIG, {
    club_id: club.value.club_id,
    mac: mac.value,
    alias: alias.value
  });
  await store.dispatch(ActionTypes.MY_CLUBS, null);
}

/**
 * Comparator per payment => ordina per data di prenotazione
 *
 * @param a
 * @param b
 */
function paymentComparator(a, b) {
  if (a.booking.start_at < b.booking.start_at) {
    return 1;
  }
  if (b.booking.start_at < a.booking.start_at) {
    return -1;
  }
  return 0;
}

function initFormValues() {
  alias.value = club.value.alias != null ? club.value.alias : "";
  paymentEnabled.value = club.value.online_payment == "ENABLED";
  forceOnlinePayment.value = club.value.force_online_payment;
  mac.value = club.value.mac != null ? club.value.mac : "";
}

function updateFormValue(value, field) {
  if (field == "alias") {
    alias.value = value;
  } else if (field == "mac") {
    mac.value = value;
  }
}

function rowFormatGameDuration(item) {
  const startAt = new Date(item.booking.start_at);
  const endAt = new Date(item.booking.end_at);
  const duration = (endAt.getTime() - startAt.getTime()) / 1000 / 60;
  return duration + " ";
}

onMounted(async function () {
  initFormValues();
  // fetchTransactions(); // Rimosso: BookingPayments gestisce autonomamente il caricamento
  //goToToday();
});

function rowFormatDate(item) {
  // INIT
  const formattedDate = moment(item.booking.date, "M/D/YYYY").format(
    "DD MMMM YYYY"
  );
  return `${formattedDate}`;
}

async function showRefund(transaction: Transaction) {
  selectedTransaction.value = transaction;
  refundPercentage.value = 100;

  refundOptions.value[0]["label"] = `${(
    (selectedTransaction.value.price * 0.25) /
    100
  ).toFixed(2)} €`;
  refundOptions.value[1]["label"] = `${(
    (selectedTransaction.value.price * 0.5) /
    100
  ).toFixed(2)} €`;
  refundOptions.value[2]["label"] = `${(
    (selectedTransaction.value.price * 0.75) /
    100
  ).toFixed(2)} €`;
  refundOptions.value[3]["label"] = `${(
    selectedTransaction.value.price / 100
  ).toFixed(2)} €`;

  showRefundModal.value = true;
}

async function refund() {
  showRefundModal.value = false;

  await store.dispatch(ActionTypes.REFUND_TRANSACTION, {
    club_id: club.value.club_id,
    bookingId: selectedTransaction.value.booking.id,
    refundPercentage: refundPercentage.value
  });
  fetchRefunds();
  selectedTab.value = 1;
}

function setRefundValue(value: number) {
  refundPercentage.value = value;
}

function onClickEvent(event: any) {
  const item = JSON.parse(JSON.stringify(event.booking));
  store.commit(MutationTypes.SET_SCROLL_EVENT, item);
  setTimeout(() => {
    router.push({ name: "Scheduler" });
  }, 100);
}

function hideModal() {
  showRefundModal.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_PadelToggle = _resolveComponent("PadelToggle")!
  const _component_PadelInput = _resolveComponent("PadelInput")!
  const _component_PadelButton = _resolveComponent("PadelButton")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_PadelRadio = _resolveComponent("PadelRadio")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_TabView, {
      class: "tab-view p-mb-5",
      activeIndex: selectedTab.value,
      onTabChange: _cache[8] || (_cache[8] = ($event: any) => (onChangeTab($event.index)))
    }, {
      default: _withId(() => [
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _hoisted_2
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode(BookingPayments)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withId(() => [
            _hoisted_4
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_PadelToggle, {
                    containerClass: "p-d-inline-flex mr-2",
                    labelClass: "color-white overflow-inherit p-size-mini p-mr-4",
                    label: "Abilitazione pagamenti online",
                    checked: paymentEnabled.value,
                    "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (paymentEnabled.value = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (handleToggleEnableNexiPayment($event)))
                  }, null, 8, ["checked"]),
                  _hoisted_9
                ]),
                _createVNode("div", _hoisted_10, [
                  (paymentEnabled.value)
                    ? (_openBlock(), _createBlock(_component_PadelToggle, {
                        key: 0,
                        containerClass: "p-d-inline-flex mr-2 ml-4",
                        labelClass: "color-white overflow-inherit p-size-mini p-mr-4",
                        label: "Accetta solo pagamenti online",
                        checked: forceOnlinePayment.value,
                        "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => (forceOnlinePayment.value = $event)),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (handleToggleForceNexiPayment($event)))
                      }, null, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", null, [
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode(_component_PadelInput, {
                            label: "Alias",
                            inputType: 'string',
                            containerClass: "full-width",
                            value: alias.value,
                            onInput: _cache[5] || (_cache[5] = ($event: any) => (updateFormValue($event, 'alias')))
                          }, null, 8, ["value"])
                        ]),
                        _createVNode("div", _hoisted_21, [
                          _createVNode(_component_PadelInput, {
                            label: "MAC",
                            inputType: 'string',
                            containerClass: "full-width",
                            value: mac.value,
                            onInput: _cache[6] || (_cache[6] = ($event: any) => (updateFormValue($event, 'mac')))
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode(_component_PadelButton, {
                          class: "p-mt-2",
                          label: "CONFERMA",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (saveNexiPaymentSettings()))
                        })
                      ])
                    ])
                  ])
                ]),
                _hoisted_23
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeIndex"]),
    (showRefundModal.value)
      ? (_openBlock(), _createBlock("div", _hoisted_24, [
          _createVNode(_component_DumbModal, {
            title: "Rimborso",
            onHide: _cache[11] || (_cache[11] = ($event: any) => (hideModal()))
          }, {
            footer: _withId(() => [
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_PadelButton, {
                  label: _unref(uppercase)('rimborsa'),
                  type: 'primary',
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (refund()))
                }, null, 8, ["label"])
              ])
            ]),
            default: _withId(() => [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_PadelRadio, {
                    value: refundPercentage.value,
                    options: refundOptions.value,
                    chipMode: true,
                    onInput: _cache[9] || (_cache[9] = ($event: any) => (setRefundValue($event))),
                    style: {"margin-top":"10px"}
                  }, null, 8, ["value", "options"])
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})